var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"24px/search"},[React.createElement("path",{"id":"Vector","d":"M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z","stroke":"#344568","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"id":"Vector_2","d":"M21 21L16.65 16.65","stroke":"#344568","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]));
}

Search.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Search;

Search.default = Search;
